export default {
	$_veeValidate: {
		value() {
			return this.selected;
		},
	},
	props: {
		value: {
			required: true,
		},
	},
	data() {
		return {
			selected: this.value,
		}
	},
	watch: {
		value(value) {
			if(!this.selected) {
				this.selected = value;
			}
		},
		selected(selected) {
			if(Array.isArray(selected)) {
				this.$emit('input', selected.map(item => item.value));
			} else {
				this.$emit('input', selected ? selected.value : '');
			}
		},
	},
}
